// extracted by mini-css-extract-plugin
export default {"wrapper":"SetUp_wrapper__6VeN2","container":"SetUp_container__gRmjI","inputGroup":"SetUp_inputGroup__HDnBb","radio":"SetUp_radio__WnOAH","radioLabel":"SetUp_radioLabel__o1KYi"};